import 'jspdf-autotable';

import { Flex } from 'antd';
import React, { useContext, useEffect, useRef } from 'react';

import useDispatchSetterStore from '../hooks/useDispatchSetterStore';
import { SmxPropsTableContext } from '../providers/propsTableProvider';
import { getSetterTable, ITableState } from '../store/slices/tableSlice';

interface IPaginationPanelContainer {
    children: React.JSX.Element | (React.JSX.Element | null | boolean)[] | null;
}

const MARGIN = 10;

const PaginationPanelContainer: React.FC<IPaginationPanelContainer> = ({ children }) => {
    const { nameQuery, prefixStore } = useContext(SmxPropsTableContext);
    const setterTable = useDispatchSetterStore<ITableState>(getSetterTable(nameQuery + prefixStore));
    const containerPaginationPanel = useRef<HTMLDivElement>(null);

    const heightContainer = containerPaginationPanel?.current?.getBoundingClientRect().height || 0;

    useEffect(() => {
        if (heightContainer > 0) {
            setterTable({ heightPaginationPanel: heightContainer + MARGIN * 2 });
        }
    }, [children]);

    return (
        <Flex ref={containerPaginationPanel} justify={'flex-end'} style={{ marginTop: MARGIN, marginBottom: MARGIN }}>
            {children}
        </Flex>
    );
};

export default PaginationPanelContainer;
